<template>
    <div class="marketing-site-filter">
        <ds-dropdown v-if="!filter.value" position="bottom-end">
            <ds-text-button id="filter-button" leading-icon="filter">
                {{ $options.MESSAGE_CONSTANTS_FILTERS.FILTER }}
            </ds-text-button>

            <ul id="filter-menu" slot="menu" class="dropdown-menu-list">
                <li
                    v-for="(element, key) in filters"
                    :key="key"
                    :class="['dropdown-menu-item', { selected: element.value === filter.value }]"
                    @click="$emit('update:filter', element)"
                >
                    {{ element.label }}
                </li>
            </ul>
        </ds-dropdown>

        <ds-chip
            v-else
            remove
            with-interaction
            @click.native="$emit('update:filter', {})"
        >
            {{ filter.label }}
        </ds-chip>
    </div>
</template>

<script>

export const MESSAGE_CONSTANTS_FILTERS = {
    FILTER: 'Filter',
    ALL: 'All',
    ACTIVE: 'Published',
    DRAFT: 'Draft',
    ACTIVE_CHANGES: 'Unpublished changes',
};

export const MESSAGE_CONSTANTS = {
    ACTIVE: 'ACTIVE',
    DRAFT: 'DRAFT',
    ACTIVE_CHANGES: 'ACTIVE_CHANGES',
};

export default {
    MESSAGE_CONSTANTS,
    MESSAGE_CONSTANTS_FILTERS,

    props: {
        filter: {
            type: Object,
            default: () => ({}),
            sync: true,
        },
    },

    data() {
        return {
            filters: [
                { label: MESSAGE_CONSTANTS_FILTERS.ALL, value: undefined },
                { label: MESSAGE_CONSTANTS_FILTERS.ACTIVE, value: MESSAGE_CONSTANTS.ACTIVE },
                { label: MESSAGE_CONSTANTS_FILTERS.ACTIVE_CHANGES, value: MESSAGE_CONSTANTS.ACTIVE_CHANGES },
                { label: MESSAGE_CONSTANTS_FILTERS.DRAFT, value: MESSAGE_CONSTANTS.DRAFT },
            ],
        };
    },
};
</script>

<style lang="scss">
    div.marketing-site-filter {
        padding-right: 2rem;
    }

    div.marketing-site-filter ul#filter-menu {
        margin-bottom: .75rem;
        margin-top: .75rem;
        padding-bottom: 0;
        padding-top: 0;
        height: max-content;
    }

    div.marketing-site-filter button#filter-button > svg {
        margin-right: .3rem;
    }

    div.marketing-site-filter ul.dropdown-menu-list {
        margin-top: 0;
        margin-bottom: 0;
    }

    div.marketing-site-filter div.menu {
        overflow: hidden;
    }
</style>
